import React from "react";
import Slider from "react-slick";
import "./GameIndustry.css";
import "../Gamecommon.css";
import logoimg1 from "../gameassets/logoimg1.png";
import logoimg2 from "../gameassets/logoimg2.png";
import logoimg3 from "../gameassets/logoimg3.png";
import logoimg4 from "../gameassets/logoimg4.png";
import logoimg5 from "../gameassets/logoimg5.png";

const cardsData = [
  {
    id: 1,
    image: logoimg1,
    title: "Real Estate",
    description: "Easy property browsing and seamless inquiry journeys."
  },
  {
    id: 2,
    image: logoimg2,
    title: "SaaS & IT",
    description: "Clean, user-friendly software dashboards and tools."
  },
  {
    id: 3,
    image: logoimg3,
    title: "FinTech & Banking",
    description: "Secure, intuitive dashboards for finance management."
  },
  {
    id: 4,
    image: logoimg4,
    title: "Healthcare",
    description: "Simplified interfaces for patient and doctor interactions."
  },
  {
    id: 5,
    image: logoimg5,
    title: "Retail & E-Commerce",
    description: "Engaging product pages and smooth checkout experiences."
  }
];

export default function GameIndustry() {
  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 600,
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: false,
    centerMode:true,
    responsive:[
      {
        breakpoint: 680,
        settings: { slidesToShow: 1, slidesToScroll: 1 },
      }
    ]
  };

  return (
    <div id="gameindustry" className="gamemainclass">
      <div className="left">
        <div className="cards">
          <div className="left-cards">
            <div className="card">
              <img src={logoimg1} alt="error" />
              <h3>End-to-End Development Expertise</h3>
              <p>From concept and design to launch and live ops, we cover the entire game development cycle.</p>
            </div>
            <div className="card">
              <img src={logoimg2} alt="error" />
              <h3>Experienced in Unity, Unreal Engine & Web3</h3>
              <p>Skilled in the latest technologies to build high-performance and future-ready games.</p>
            </div>
          </div>
            <div className="leftmain">
              <div className="card">
                <img src={logoimg3} alt="error" />
                <h3>Global Delivery with Scalable Solutions</h3>
                <p>
                 Flexible development models that adapt to your business needs and target markets.
</p>
              </div>
              <div className="card">
                <img src={logoimg4} alt="error" />
                <h3>Dedicated Team of Experts</h3>
                <p>
             Game designers, developers, artists, and blockchain specialists working together for success.
   </p>
              </div>
            </div>
            <div className="rightmain">
              <div className="card">
                <img src={logoimg5} alt="error" />
                <h3>Proven Track Record of Successful Projects</h3>
                <p> Delivering engaging mobile, PC, console, and blockchain games that attract players and generate revenue.</p>
              </div>
            </div>
       </div>
      </div>

      <div className="right">
        {/* <span className="span-tag">Industries We Serve</span> */}
        <h2 className="h2-tag">Expertise & Innovation in Game Development</h2>
        <p className="p-tag">
        Bastionex offers blockchain game development services, transforming ideas into immersive mobile, PC, console, AR/VR, and blockchain games that deliver engaging, high-performing experiences.
        </p>
      </div>

     <div className="mobile-cards-left">
        <Slider {...sliderSettings}>
          {cardsData.map((card) => (
            <div key={card.id} className="card">
              <img src={card.image} alt={card.title} />
             <div className="content">
               <h3>{card.title}</h3>
              <p>{card.description}</p>
             </div>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
}
